import { useEffect, useState } from 'react';

export const useIsChromiumBrowser = () => {
  /**
   * optimistically beliving that browser is chromim based (As use case action is triggered only when not chromium based)
   * you may want to re-think depending on your use case (until first render we will assume it is chromium based)
   */
  const [isChromiumBrowser, setIsChromiumBrowser] = useState(true);

  useEffect(() => {
    const userAgent = navigator.userAgent;

    const isChromiumBased =
      /Chrome/.test(userAgent) ||
      /Chromium/.test(userAgent) ||
      /Edg/.test(userAgent) ||
      /OPR/.test(userAgent) ||
      userAgent.includes('Brave');
    setIsChromiumBrowser(isChromiumBased);
  }, []);

  return { isChromiumBrowser };
};
